// ==============================|| THEME CONSTANT  ||============================== //
export let ThemeMode;

export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = '350px';

(function (ThemeMode) {
	ThemeMode['LIGHT'] = 'light';
	ThemeMode['DARK'] = 'dark';
})(ThemeMode || (ThemeMode = {}));


export let MenuOrientation;

(function (MenuOrientation) {
	MenuOrientation['VERTICAL'] = 'vertical';
	MenuOrientation['HORIZONTAL'] = 'horizontal';
})(MenuOrientation || (MenuOrientation = {}));

export let ThemeDirection;

(function (ThemeDirection) {
	ThemeDirection['LTR'] = 'ltr';
	ThemeDirection['RTL'] = 'rtl';
})(ThemeDirection || (ThemeDirection = {}));

// ==============================|| THEME CONFIG  ||============================== //

const config = {
	fontFamily: `'ATAndreSans'`,
	/**
	 * the props used for default theme palette mode
	 * explore the default theme
	 * below theme options -
	 * 'light' (default) - ThemeMode.LIGHT
	 * 'dark' - ThemeMode.DARK
	 */
	mode: ThemeMode.LIGHT,
	/**
	 * the props used for show mini variant drawer
	 * the mini variant is recommended for apps sections that need quick selection access alongside content.
	 * default - false
	 */
	miniDrawer: false,
	/**
	 * the props used for theme container.
	 * the container centers your content horizontally. It's the most basic layout element.
	 * default - true which show container
	 * false - will show fluid
	 */
	container: true,
	/**
	 * the props used for theme primary color variants
	 */
	presetColor: 'default',
	/**
	 * the props used for menu orientation (diffrent theme layout).
	 * we provide static below options -
	 * 'vertical' (default) - MenuOrientation.VERTICAL
	 * 'horizontal' - MenuOrientation.HORIZONTAL
	 */
	menuOrientation: MenuOrientation.VERTICAL,
	/**
	 * the props used for default theme direction
	 * explore the default theme
	 * below theme options -
	 * 'ltr' (default) - ThemeDirection.LTR
	 * 'rtl' - ThemeDirection.RTL
	 */
	themeDirection: ThemeDirection.LTR
};

export default config;
